import { DataHeader, DataSource, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCommissionsRoles extends Layout {
    dataheaderCommissionsRoles: DataHeader;
    sourceCommissionRole: DataSource;
    switchIsActive: Switch;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
